module.exports = __webpack_public_path__ + "img/jn-bottom.73ca79f6.png";